export function useDocumentTitle(base: string, subtitle?: string) {
    const setTitle = (text?: string) => {
        document.title = text ? `${text} | ${base}` : `${base}`;
    };

    setTitle(subtitle);

    return { setTitle };
}
